(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["compre-o-look"] && !Shopify.designMode) return;
  try {
    
var lookBook = new Swiper(".slide-look-itens", { 
    pagination: {
      el: ".swiper-pagination",
      clickable: true, 
    },
	navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    }
});

var lookBookItens = new Swiper(".slide-look-itens-products", { 
    pagination: {
      el: ".swiper-pagination",
      clickable: true, 
    }
});

  } catch(e) { console.error(e); }
})();
})();
